import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import loaderimage from "../../images/giphy.gif";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";

const CityList = () => {
  const [cityList, setCityList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [actionType, setActionType] = useState("");
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState('');
  const [filteredCity, setFilteredCity] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const headers = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
  };


  const apiCallCityList = async () => {
    try {
      setLoader(true);
      setError("");
      const url = process.env.REACT_APP_API_URL + "cities/showallcities";
      const response = await axios.get(url);
      setCityList(response.data);
      setFilteredCity(response.data);
    } catch (error) {
      setError("Not Found!!!");
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    apiCallCityList();
  }, []);

  const handleAction = async () => {
    if (!selectedCityId) return;

    try {
      let url = "";
      if (actionType === "Delete") {
        url = `${process.env.REACT_APP_API_URL}cities/deletecity/${selectedCityId}`;
        await axios.put(url, {}, { headers });
        setSuccessMessage("City deleted successfully.");
      }

      apiCallCityList();
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error deleting City:", error);
      setFailureMessage("Failed to delete city . Please try again.");
      setShowFailureModal(true);
    }
  };

  const triggerActionModal = (action, cityId) => {
    setSelectedCityId(cityId);
    setActionType(action);
    if (action === "Delete") {
      setModalMessage("Are you sure you want to delete this city?");
    }
    setShowModal(true);
  };
const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (searchTerm === "") {
        setFilteredCity(cityList);
      } else {
        const filtered = cityList.filter(
          (city) =>
            city?.city_name?.toLowerCase().includes(searchTerm) ||
            city?.post_code?.toLowerCase().includes(searchTerm)||
            city?.country?.toLowerCase().includes(searchTerm)||
            city?.state_name?.toLowerCase().includes(searchTerm)
        );
        setFilteredCity(filtered);
      }
    }, 200);
    return () => clearTimeout(debounceTimeout);
  }, [searchTerm, cityList]);


  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-black fw-bold">City Management</h2>
        <div className="d-flex gap-2 align-items-center  w-50">
            <span className="fw-bold text-secondary text-nowrap">{filteredCity.length} results</span>
            <input
              type="text"
              className="form-control"
              placeholder="Search by City Id or City Name"
              value={searchTerm}
              onChange={handleSearch}
            />
          <Link to="/cityadd" className="btn bg-info">+ Add New City</Link>
        </div>
      </div>
      <div className="card shadow-sm border-0 rounded">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0 text-white">City List</h5>
        </div>
          <div className="card-body p-0">
            <div className="table-responsive sticky-table-container">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light position-sticky top-0" >
            <tr>
              <th>Sr No</th>
              <th>City ID</th>
              <th>City Name</th>
              <th>State Name</th>
              <th>Country Name</th>
              <th>Pincode Name</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
          {loader ? (
                   <tr>
                   <td colSpan={10} className="text-center py-2">
                     <img src={loaderimage} alt="Loading..." height="40" />
                   </td>
                 </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan={10} className="text-center text-danger fw-bold py-3">
                      <div className="alert alert-danger text-center m-3" role="alert">
            Oops! Something went wrong. Please try again later.
          </div>
                      </td>
                    </tr>
                  ) : filteredCity.length > 0 ? (
                  filteredCity.map((item, index) => (
                  <tr key={item.city_id} className="border-bottom">
                    <td>{index + 1}</td>
                    <td>{item.city_id}</td>
                    <td>{item.city_name}</td>
                    <td>{item.state_name}</td>
                    <td>{item.country}</td>
                    <td>{item.post_code}</td>
                    <td className="text-center">
                    <div className="d-flex justify-content-center gap-2">
                      <Link
                        to={`/cityedit/${item.city_id}`}
                        className="btn btn-sm btn-outline-warning"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() =>
                          triggerActionModal("Delete", item.city_id)
                        }
                        className="btn btn-sm btn-outline-secondary" 
                      >
                        Delete
                      </button>
                      </div>
                    </td>
                   
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} className="text-center  text-muted fw-bold">
                  <div className="alert alert-secondary text-center m-3" role="alert">
                  No Cities available
                </div>
                  </td>
                </tr>
              )}
                </tbody>
              </table>
            </div>
        </div>
        </div>

        {/* Confirmation Modal for Actions */}
        <ConfirmationModal
          show={showModal}
          onHide={() => setShowModal(false)}
          modalMessage={modalMessage}
          confirmation={handleAction}
          operationType={actionType}
        />

        {/* Success Confirmation Modal */}
        <NewconfirmationModal
          show={showSuccessModal}
          onHide={() => setShowSuccessModal(false)}
          modalMessage={successMessage}
          operationType="OK"
          timeoutDuration={3000}
        />
        <AllFailureModal 
        show={showFailureModal} 
        onHide={() => setShowFailureModal(false)} 
        modalMessage={failureMessage}  
        operationType="OK" 
        timeoutDuration={3000}/>
      </div>
    </>
  );
};

export default CityList;
